import { useRef } from "react";
import { StepTree } from "~/components/build/Show/components/Sidebar/StepTree";
import {
  DisplayMode,
  useFilterStore,
} from "~/components/build/Show/components/Sidebar/useFilterStore";
import { useTreeNodes } from "~/components/build/Show/components/Sidebar/useTreeNodes";
import { Table } from "~/components/build/Show/pages/steps/table";

export const MobileStepsView = () => {
  const displayMode = DisplayMode.Pipeline;
  const filters = useFilterStore((state) => state.filterBy);
  const scrollRef = useRef<HTMLDivElement>(null);
  const { isLoading, nodes } = useTreeNodes({ displayMode, filters });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (Features.HideBuildSidebar) {
    return (
      <div className="relative h-full w-full flex-auto">
        <Table className="absolute" />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full overflow-auto" ref={scrollRef}>
      <StepTree nodes={nodes} displayMode={displayMode} scrollRef={scrollRef} />
    </div>
  );
};
